export default function auth ({ next, store }) {
  return !store.getters.GET_AUTHORIZATION ? next({
    name: 'main'
  }) : next()
}
